import { render, staticRenderFns } from "./InstructorForm.vue?vue&type=template&id=510453c0&"
import script from "./InstructorForm.vue?vue&type=script&lang=js&"
export * from "./InstructorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports